module.exports = __webpack_public_path__ + "img/2_2.b1becf96.png";